export enum AdditionalInformation {
  GET_ADDITIONAL_INFORMATION = "GET_ADDITIONAL_INFORMATION",
  GET_ADDITIONAL_INFORMATION_SUCCESS = "GET_ADDITIONAL_INFORMATION_SUCCESS",
  GET_ADDITIONAL_INFORMATION_FAIL = "GET_ADDITIONAL_INFORMATION_FAIL",

  HANDLE_ADDITIONAL_INFORMATION_DRAWER = "HANDLE_ADDITIONAL_INFORMATION_DRAWER",
  RESET_ADDITIONAL_INFORMATION_DATA = "RESET_ADDITIONAL_INFORMATION_DATA",

  NEW_ADDITIONAL_INFORMATION = "NEW_ADDITIONAL_INFORMATION",
  NEW_ADDITIONAL_INFORMATION_SUCCESS = "NEW_ADDITIONAL_INFORMATION_SUCCESS",
  NEW_ADDITIONAL_INFORMATION_FAIL = "NEW_ADDITIONAL_INFORMATION_FAIL",

  UPDATE_ADDITIONAL_INFORMATION = "UPDATE_ADDITIONAL_INFORMATION",
  UPDATE_ADDITIONAL_INFORMATION_SUCCESS = "UPDATE_ADDITIONAL_INFORMATION_SUCCESS",
  UPDATE_ADDITIONAL_INFORMATION_FAIL = "UPDATE_ADDITIONAL_INFORMATION_FAIL",

  DELETE_ADDITIONAL_INFORMATION = "DELETE_ADDITIONAL_INFORMATION",
  DELETE_ADDITIONAL_INFORMATION_SUCCESS = "DELETE_ADDITIONAL_INFORMATION_SUCCESS",
  DELETE_ADDITIONAL_INFORMATION_FAIL = "DELETE_ADDITIONAL_INFORMATION_FAIL",

  GET_INFORMATION_META_DATA = "GET_INFORMATION_META_DATA",
  GET_INFORMATION_META_DATA_SUCCESS = "GET_INFORMATION_META_DATA_SUCCESS",
  GET_INFORMATION_META_DATA_FAIL = "GET_INFORMATION_META_DATA_FAIL",

  GET_DATA_TYPE_VALUES = "GET_DATA_TYPE_VALUES",
  GET_DATA_TYPE_VALUES_SUCCESS = "GET_DATA_TYPE_VALUES_SUCCESS",
  GET_DATA_TYPE_VALUES_FAIL = "GET_DATA_TYPE_VALUES_FAIL",
}
